import { FormikField } from 'components/common/form/field/FormikField';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { connect } from 'formik';
import i18next from 'i18n';
import { FC, useCallback } from 'react';
import styles from './agencyForm.module.scss';
import { isAnyChannelPricingModeEnabled } from './agencyAddonVisibility';

const AgencyOtherSettingsForm: FC<any> = (props) => {
  const { addonFeatures } = props.formik.values;
  const setFieldValue = props.formik.setFieldValue;

  // 再行銷追蹤需依賴 COMBO 廣告類型 add-on 才顯示；
  // 關閉時的值 reset 由 normalizeAddonFeatures 統一處理
  const isComboAdTypeEnabled =
    !!addonFeatures?.adTypes?.[`adType_${AdType.COMBO}`];

  // 影片廣告觀看目標需依賴任一 channel 啟用 fix_cpv 才顯示；
  // 都沒開時的值 reset 由 normalizeAddonFeatures 統一處理
  const isAnyFixCpvEnabled = isAnyChannelPricingModeEnabled(
    addonFeatures,
    'fix_cpv'
  );

  const onOrderAgcProfitSettingChange = useCallback(
    (open) => {
      setFieldValue('addonFeatures.company.agencyProfit', open);
    },
    [setFieldValue]
  );
  return (
    <div className={styles.agencyFrom}>
      <fieldset>
        <legend>
          <span>{i18next.t('agencyDetail.labels.otherSettingsTab')}</span>
        </legend>
        <div className={styles.sectionsShadow}>
          <div className={styles.fieldContent}>
            <FormikField.Switch
              label={i18next.t('agency.addonItem.campaign.bid_weight_setting')}
              name='addonFeatures.campaign.bid_weight_setting'
            />
            <FormikField.Switch
              label={i18next.t(
                'agency.addonItem.campaign.admin_bid_price_setting'
              )}
              name='addonFeatures.campaign.admin_bid_price_setting'
            />
            <FormikField.Switch
              label={i18next.t(
                'agency.addonItem.campaign.orderAgcProfitSetting'
              )}
              name='addonFeatures.campaign.orderAgcProfitSetting'
              onChange={onOrderAgcProfitSettingChange}
            />
            <FormikField.Switch
              label={i18next.t('agency.addonItem.campaign.budgetDominate')}
              name='addonFeatures.campaign.budgetDominate'
            />
            {isAnyFixCpvEnabled && (
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.campaign.videoAdViewObjective'
                )}
                name='addonFeatures.campaign.videoAdViewObjective'
              />
            )}
            <FormikField.Switch
              label={i18next.t('agency.addonItem.campaign.thirdparty_tracking')}
              name='addonFeatures.campaign.thirdparty_tracking'
            />
            {isComboAdTypeEnabled && (
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.campaign.retargeting_tracker'
                )}
                name='addonFeatures.campaign.retargeting_tracker'
              />
            )}
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default connect(AgencyOtherSettingsForm);
